import { PrimaryButton } from "@cxc/react-fds-components";
import { FeatureText } from "@cxc/react-hydro-components";
import {
  UniversalContext,
  useUniversalContext,
} from "@cxc/react-universal-components";
import React, { useEffect } from "react";
import "./BaseErrorPage.css";
import { ErrorHeading, languageMap } from "./BaseErrorPageDefaultState";

const getHeadingTextByLanguage = (languageCode: string): ErrorHeading => {
  return languageMap[languageCode] || languageMap["en-us"];
};

export const BaseErrorPage = () => {
  const { language, setScopedValue, navigate } =
    useUniversalContext() as UniversalContext;

  useEffect(() => {
    setScopedValue("fpg_header", "view_error", true);
  }, [setScopedValue]);

  const { headingText, buttonText } = getHeadingTextByLanguage(language);
  return (
    <div
      id="BaseErrorPage"
      data-testid={"BaseErrorPage"}
      className="fds-layout-grid fmc-py-10"
    >
      <FeatureText dataTestId="ErrorSection" headingText={headingText} />
      <div className={"base-error fmc-mt-4"}>
        <PrimaryButton
          onClick={() => navigate("contact-us")}
          title={buttonText}
        />
      </div>
    </div>
  );
};

export default BaseErrorPage;
